export default "__VITE_ASSET__DsUiJ$0H__"